import './assets/base.css';
import './assets/materialSymbols.css';

import type { AuthService } from '@inform-appshell/fusion-kit-contracts';
import { VueQueryPlugin } from '@tanstack/vue-query';
import { createApp, type App } from 'vue';

import { client } from './api';
import Root from './App.vue';
import { createAppRouter } from './router';
import { installVuetifyRuntime } from './runtime/installVuetifyRuntime';
import { setupTokenInterceptors } from './services/tokenInterceptors';

export interface SetupConfig {
  basePath: string;
  authService: AuthService;
  /** API origin for the generated client. Resolved from runtime config.json. */
  apiBaseUrl: string;
}

export function setupApp(config: SetupConfig): App {
  client.setConfig({ baseURL: config.apiBaseUrl });

  const app = createApp(Root);

  app.use(VueQueryPlugin, {
    queryClientConfig: {
      defaultOptions: {
        queries: { staleTime: 1000 * 60 * 5, retry: 1 },
      },
    },
  });

  app.use(createAppRouter(config.basePath));
  installVuetifyRuntime(app);

  setupTokenInterceptors(client.instance, config.authService);

  return app;
}
